import React from 'react';
import styled from 'styled-components';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import NoticeCard from '../../components/common/NoticeCard';
import { useNavigate } from 'react-router-dom';

const ArchiveHome: React.FC = () => {
  const navigate = useNavigate();

  // 더미 데이터 - 실제로는 API에서 가져와야 함
  const archivePosts = [
    {
      id: 1,
      title: "공지사항 게시판에 표시되는 게시글 카드입니다.",
      author: "관리자",
      date: "2025년 0월 0일 00:00",
      content: "별 하나에 추억과 별 하나에 사랑과 별 하나에 쓸쓸함과 별 하나에 동경과 별 하나에 시와 별 하나에 어머니, 어머니, 어머님, 나는 별 하나에 아름다운 말 한 마디씩 불러 봅니다...",
    },
    {
      id: 2,
      title: "공지사항 게시판에 표시되는 게시글 카드입니다.",
      author: "관리자", 
      date: "2025년 0월 0일 00:00",
      content: "별 하나에 추억과 별 하나에 사랑과 별 하나에 쓸쓸함과 별 하나에 동경과 별 하나에 시와 별 하나에 어머니, 어머니, 어머님, 나는 별 하나에 아름다운 말 한 마디씩 불러 봅니다...",
    }
  ];

  const handlePostClick = (postId: number) => {
    navigate(`/archive/${postId}`);
  };

  return (
    <LayoutContainer>
      <Header />
      <MainContent>
        <ContentArea>
          <Container>
            <MainContainer>
              {/* 페이지 헤더 */}
              <PageHeader>
                <PageTitle>아카이브</PageTitle>
              </PageHeader>

              {/* 브레드크럼 */}
              <NavigationBar>
                <BreadcrumbContainer>
                  <BreadcrumbItem>홈</BreadcrumbItem>
                  <ChevronIcon>
                    <svg width="8" height="16" viewBox="0 0 8 16" fill="none">
                      <path 
                        d="M1.73 3.07L6.26 7.6L1.73 12.13" 
                        stroke="rgba(55, 56, 60, 0.61)" 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      />
                    </svg>
                  </ChevronIcon>
                  <BreadcrumbItem>아카이브</BreadcrumbItem>
                </BreadcrumbContainer>
              </NavigationBar>

              {/* 아카이브 이용 안내 */}
              <NoticeSection>
                <NoticeCard title="아카이브 이용 안내" />
              </NoticeSection>

              {/* 게시글 목록 */}
              <PostsList>
                {archivePosts.map((post, index) => (
                  <React.Fragment key={post.id}>
                    <PostCard onClick={() => handlePostClick(post.id)}>
                      <PostContent>
                        <PostHeader>
                          <PostTitle>{post.title}</PostTitle>
                        </PostHeader>
                        
                        <PostFooter>
                          <PostAuthorInfo>
                            <AuthorAvatar>
                              <img src="/images/default-avatar.png" alt="작성자" />
                            </AuthorAvatar>
                            <AuthorName>{post.author}</AuthorName>
                            <Divider />
                            <PostDate>{post.date}</PostDate>
                          </PostAuthorInfo>
                        </PostFooter>
                      </PostContent>
                    </PostCard>
                    <PostDivider />
                  </React.Fragment>
                ))}
              </PostsList>
            </MainContainer>
          </Container>
        </ContentArea>
      </MainContent>
      <Footer />
    </LayoutContainer>
  );
};

// 스타일 컴포넌트들
const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 320px;
  overflow-x: hidden;
`;

const MainContent = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  position: relative;
  min-height: calc(100vh - 80px);
  align-items: flex-start;
  justify-content: center;
`;

const ContentArea = styled.main`
  width: 100%;
  min-height: calc(100vh - 80px);
  background: white;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const Container = styled.div`
  width: 100%;
  min-height: 880px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const MainContainer = styled.div`
  width: 1200px;
  padding-top: 144px; /* 헤더 높이(80px) + 여유 공간(64px) */
  padding-bottom: 128px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
`;

const PageHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`;

const PageTitle = styled.h1`
  color: var(--Label-Normal, #171719);
  font-size: 40px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 700;
  line-height: 52px;
  margin: 0;
`;

const NavigationBar = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BreadcrumbContainer = styled.div`
  flex: 1;
  height: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const BreadcrumbItem = styled.span`
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-size: 16px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.09px;
`;

const ChevronIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NoticeSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`;

const PostsList = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const PostCard = styled.div`
  align-self: stretch;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  cursor: pointer;
`;

const PostContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
`;

const PostHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
`;

const PostTitle = styled.h3`
  align-self: stretch;
  color: var(--Label-Normal, #171719);
  font-size: 18px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 600;
  line-height: 26.01px;
  margin: 0;
`;

const PostFooter = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
`;

const PostAuthorInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const AuthorAvatar = styled.div`
  position: relative;
  border-radius: 10000px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: var(--Static-White, white);
  overflow: hidden;
  outline: 1px solid var(--Line-Normal-Alternative, rgba(112, 115, 124, 0.08));
  outline-offset: -1px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const AuthorName = styled.span`
  color: var(--Label-Neutral, rgba(46, 47, 51, 0.88));
  font-size: 14px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 600;
  line-height: 20.01px;
  letter-spacing: 0.20px;
`;

const PostDate = styled.span`
  color: var(--Label-Alternative, rgba(55, 56, 60, 0.61));
  font-size: 14px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 400;
  line-height: 20.01px;
  letter-spacing: 0.20px;
`;

const Divider = styled.div`
  width: 1px;
  height: 12px;
  background: var(--Line-Normal-Normal, rgba(112, 115, 124, 0.22));
`;

const PostDivider = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  
  &::after {
    content: '';
    align-self: stretch;
    height: 1px;
    background: var(--Line-Normal-Normal, rgba(112, 115, 124, 0.22));
  }
`;

export default ArchiveHome;
